import React from 'react';
import PropTypes from 'prop-types';
import CopyrightSection from './CopyrightSection';
import DisclaimerSection from './DisclaimerSection';
import FooterLogo from './FooterLogo';
import NavLinks from './NavLinks';
import SocialLinks from './SocialLinks';
import { Row, Col, Container } from '../../base/Grid';

import {
  FooterSection, FafaCol, FafaLink, FafaTypography,
} from './styles';

export const Footer = ({
  config,
  disclaimerFootnotes,
  customDisclaimers,
  isAmp,
  legalCopy,
  appendFooter,
}) => {
  const { basePath, nmxTemplateVersion } = config;

  return (
    // TODO: remove class "nmx-base" once nmx-template 1.0.x is implemented and "nmx-base" is added to body tag
    <footer id="footer">
      <Container>
        <h3 className="nmx-assistive-text">
          Find What You&#39;re Looking for at Northwestern Mutual
        </h3>
        <DisclaimerSection disclaimerFootnotes={disclaimerFootnotes} customDisclaimers={customDisclaimers} isAmp={isAmp} />
        <FooterSection style={{ paddingTop: '2rem' }}>
          <Row align='left'>
            <Col>
              <FooterLogo isAmp={isAmp} basePath={basePath} nmxTemplateVersion={nmxTemplateVersion} />
            </Col>
          </Row>
          <Row>
            <Col nested xsmall={12} medium={8} large={5}>
              <NavLinks basePath={basePath} />
            </Col>
            <Col xsmall={12} medium={4} large={3} className='nmx-no-print'>
              <SocialLinks />
            </Col>
            <FafaCol xsmall={12} large={4}>
              <FafaTypography component='h4' variant='h5' weight={300} disableBottomPadding={true}>
                Over 6,400 Financial Advisors and Professionals Nationwide&#42;
              </FafaTypography>
              <FafaLink
                href="/find-a-financial-advisor/"
                variant='secondary'
                className='nmx-no-print'
                config={config}
              >
                Find an Advisor
              </FafaLink>
            </FafaCol>
          </Row>
        </FooterSection>
        <CopyrightSection legalCopy={legalCopy} appendFooter={appendFooter} />
      </Container>
    </footer>
  );
};

Footer.propTypes = {
  /** Config vars used in footer */
  config: PropTypes.shape({
    basePath: PropTypes.string.isRequired,
    nmxTemplateVersion: PropTypes.string.isRequired,
  }).isRequired,

  disclaimerFootnotes: PropTypes.any,
  customDisclaimers: PropTypes.any,
  isAmp: PropTypes.bool,
  legalCopy: PropTypes.any,
  appendFooter: PropTypes.any,
};

Footer.defaultProps = {
  isAmp: false,
};

export default Footer;
